import moment from 'moment'

export default function formatTimeslot(startTime, endTime) {
    return `${moment(startTime).format('MM/DD/YY hh:mma')} - ${moment(endTime).format('hh:mma')}`
}